import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { Button, Loader, Row, Text } from 'Components/UI'
import { EventItem } from 'Types/emajinAPI'

import { EVENT_DETAILS, EVENT_RSVP } from 'Constants/Paths'

import { usePaginatedFetch } from 'Hooks'

import APIService from 'Services/API'

import Card from './Card'
import { Container } from './styles'

const LIST_LIMIT = 10

function EventsList() {
  const router = useRouter()

  const fetchPage = useCallback(async (page: number) => {
    const res = await APIService.getEvents({
      limit: LIST_LIMIT,
      offset: page * LIST_LIMIT,
    })
    return res.events ?? []
  }, [])

  const {
    items: events,
    loading,
    error,
    hasMore,
    loadMore,
    loadingMore,
  } = usePaginatedFetch<EventItem>({
    limit: LIST_LIMIT,
    fetchPage,
  })

  const handleReadMoreClick = useCallback(
    (data: EventItem) => {
      sessionStorage.setItem('event', JSON.stringify(data))
      router.push(EVENT_DETAILS(data.id))
    },
    [router],
  )

  const handleRSVP = useCallback(
    (data: EventItem) => {
      sessionStorage.setItem('event', JSON.stringify(data))
      router.push(EVENT_RSVP(data.id))
    },
    [router],
  )

  if (error) return null

  return (
    <Container>
      {loading ? (
        <Row alignCenter fullWidth height={624} justifyCenter>
          <Loader size={32} />
        </Row>
      ) : (
        <>
          {events.map(item => (
            <Card
              data={item}
              key={item.id}
              onRSVP={() => handleRSVP(item)}
              onReadMore={() => handleReadMoreClick(item)}
            />
          ))}

          {error ? (
            <Row fullWidth justifyCenter>
              <Text inverse screen18>
                Failed to load events
              </Text>
            </Row>
          ) : null}

          {hasMore ? (
            <Row alignCenter fullWidth height={72} justifyCenter>
              {loadingMore ? (
                <Loader size={24} />
              ) : (
                <Button secondary onClick={loadMore}>
                  Load more
                </Button>
              )}
            </Row>
          ) : null}
        </>
      )}
    </Container>
  )
}

export default EventsList
